import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { BatchRejectBody, BatchRejectResponse } from "@/core/types";
import { cosignatureKeys } from "@/features/cosignature/api/keyFactory";
import { showToast } from "@/providers/ToastProvider";

import { batchRejectAction } from "../queryFunctions/batchRejectAction";

export function useBatchRejectDocuments({
  onSuccess,
  ...options
}: UseMutationOptions<BatchRejectResponse, unknown, BatchRejectBody> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: batchRejectAction,
    ...options,
    onError: () => {
      showToast([{ heading: "Something went wrong. Please try again.", variant: "error" }]);
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: cosignatureKeys.base });
      onSuccess?.(data, variables, context);
      showToast([
        { heading: "Notes rejected with your feedback.", variant: "success" },
        { delay: 500 },
      ]);
    },
  });
}
